import type { JSX } from 'react';
import React from 'react';
import { KeyboardBadge } from '@bynder/design-system';
import { Translate } from '@bynder/localization';

const clientOS = navigator.userAgent.toLowerCase();
const isCommandKey = clientOS.includes('mac');

export function Shift(): JSX.Element {
    return (
        <KeyboardBadge icon="shift">
            <Translate id="modal.shortcuts.keys.shift" />
        </KeyboardBadge>
    );
}

export function Cmd(): JSX.Element {
    return (
        <KeyboardBadge icon="command">
            <Translate id="modal.shortcuts.keys.cmd" />
        </KeyboardBadge>
    );
}

export function Ctrl(): JSX.Element {
    return (
        <KeyboardBadge icon="control">
            <Translate id="modal.shortcuts.keys.control" />
        </KeyboardBadge>
    );
}

export function Space(): JSX.Element {
    return (
        <KeyboardBadge icon="spacebar">
            <Translate id="modal.shortcuts.keys.space" />
        </KeyboardBadge>
    );
}

export function BackSpace(): JSX.Element {
    return (
        <KeyboardBadge icon="backspace">
            <Translate id="modal.shortcuts.keys.backspace" />
        </KeyboardBadge>
    );
}

export function ArrowLeft(): JSX.Element {
    return (
        <KeyboardBadge icon="left" isLabelHidden>
            <Translate id="modal.shortcuts.arrows.left" />
        </KeyboardBadge>
    );
}

export function ArrowRight(): JSX.Element {
    return (
        <KeyboardBadge icon="right" isLabelHidden>
            <Translate id="modal.shortcuts.arrows.right" />
        </KeyboardBadge>
    );
}

export function ArrowUp(): JSX.Element {
    return (
        <KeyboardBadge icon="up" isLabelHidden>
            <Translate id="modal.shortcuts.arrows.up" />
        </KeyboardBadge>
    );
}

export function ArrowDown(): JSX.Element {
    return (
        <KeyboardBadge icon="down" isLabelHidden>
            <Translate id="modal.shortcuts.arrows.down" />
        </KeyboardBadge>
    );
}

export function Option(): JSX.Element {
    return (
        <KeyboardBadge icon="option">
            <Translate id="modal.shortcuts.keys.option" />
        </KeyboardBadge>
    );
}

export function Alt(): JSX.Element {
    return (
        <KeyboardBadge>
            <Translate id="modal.shortcuts.keys.alt" />
        </KeyboardBadge>
    );
}

export function Options(): JSX.Element {
    return isCommandKey ? <Option /> : <Alt />;
}

export function Command(): JSX.Element {
    return isCommandKey ? <Cmd /> : <Ctrl />;
}
